var _g, _path, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotlightBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 223,
    viewBox: "0 0 212 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_22254_1622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2503 33.2774C95.2637 27.5282 104.736 27.5282 110.75 33.2774L129.322 51.0338C131.696 53.3038 134.728 54.7639 137.983 55.2049L163.446 58.6544C171.69 59.7713 177.596 67.1773 176.85 75.4633L174.547 101.055C174.253 104.326 175.002 107.607 176.687 110.427L189.865 132.485C194.132 139.627 192.024 148.862 185.081 153.445L163.637 167.601C160.896 169.411 158.798 172.042 157.643 175.117L148.614 199.173C145.691 206.962 137.156 211.072 129.244 208.501L104.807 200.562C101.683 199.547 98.3174 199.547 95.1933 200.562L70.7559 208.501C62.8436 211.072 54.3091 206.962 51.3857 199.173L42.3567 175.117C41.2025 172.042 39.1043 169.411 36.3629 167.601L14.9189 153.445C7.97578 148.862 5.86794 139.627 10.1349 132.485L23.3134 110.427C24.9981 107.607 25.7469 104.326 25.4525 101.055L23.1497 75.4633C22.4041 67.1773 28.3101 59.7713 36.5543 58.6544L62.0166 55.2049C65.2717 54.7639 68.3036 53.3038 70.6779 51.0338L89.2503 33.2774Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0186 34.0801C95.5152 28.8254 104.124 28.7433 109.718 33.834L109.981 34.0801L128.555 51.8369C130.94 54.117 133.944 55.6351 137.184 56.2051L137.834 56.3057L163.297 59.7559C170.832 60.777 176.264 67.4563 175.771 75.0039L175.743 75.3633L173.44 100.955C173.145 104.241 173.832 107.536 175.406 110.425L175.732 110.997L188.911 133.055C192.811 139.583 190.976 147.995 184.768 152.315L184.469 152.518L163.025 166.674C160.272 168.492 158.123 171.082 156.847 174.114L156.603 174.727L147.574 198.783C144.902 205.902 137.181 209.711 129.933 207.552L129.587 207.444L105.15 199.505C102.012 198.485 98.6469 198.421 95.4805 199.313L94.8496 199.505L70.4121 207.444C63.1797 209.794 55.3876 206.133 52.5566 199.119L52.4258 198.783L43.3975 174.727C42.2381 171.638 40.1892 168.967 37.5176 167.048L36.9746 166.674L15.5312 152.518C9.18485 148.328 7.18879 139.954 10.9072 133.367L11.0889 133.055L24.2676 110.997C25.9598 108.165 26.7706 104.898 26.6055 101.612L26.5596 100.955L24.2568 75.3633C23.5755 67.7894 28.8787 61.0078 36.3467 59.8086L36.7031 59.7559L62.166 56.3057C65.4355 55.8627 68.4953 54.4607 70.9609 52.2832L71.4453 51.8369L90.0186 34.0801Z",
    stroke: "#4B4B4B",
    strokeOpacity: 0.6,
    strokeWidth: 2.22222
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_22254_1622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.222,
    cy: 106.333,
    rx: 22.2222,
    ry: 38.8889,
    fill: "#E3E1DE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_22254_1622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.557 105.019C114.272 101.849 118.789 101.849 119.504 105.019L121.71 114.814C121.969 115.962 122.865 116.859 124.013 117.117L133.808 119.324C136.979 120.038 136.979 124.556 133.808 125.27L124.013 127.476C122.865 127.735 121.969 128.632 121.71 129.78L119.504 139.575C118.789 142.745 114.272 142.745 113.557 139.575L111.351 129.78C111.092 128.632 110.196 127.735 109.048 127.476L99.2529 125.27C96.0824 124.556 96.0824 120.038 99.2529 119.324L109.048 117.117C110.196 116.859 111.092 115.962 111.351 114.814L113.557 105.019Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_22254_1622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2162 92.098C80.5733 90.5127 82.8322 90.5127 83.1893 92.098L84.2925 96.9954C84.4218 97.5695 84.8702 98.0178 85.4442 98.1471L90.3416 99.2503C91.9269 99.6074 91.9269 101.866 90.3416 102.223L85.4442 103.327C84.8702 103.456 84.4218 103.904 84.2925 104.478L83.1893 109.376C82.8322 110.961 80.5733 110.961 80.2162 109.376L79.113 104.478C78.9837 103.904 78.5354 103.456 77.9613 103.327L73.0639 102.223C71.4787 101.866 71.4787 99.6074 73.0639 99.2503L77.9613 98.1471C78.5354 98.0178 78.9837 97.5695 79.113 96.9954L80.2162 92.098Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_22254_1622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4405 130.141C78.9762 127.763 82.3646 127.763 82.9002 130.141L84.555 137.487C84.749 138.348 85.4214 139.021 86.2826 139.215L93.6286 140.869C96.0065 141.405 96.0065 144.793 93.6286 145.329L86.2826 146.984C85.4214 147.178 84.749 147.85 84.555 148.711L82.9002 156.057C82.3646 158.435 78.9762 158.435 78.4405 156.057L76.7858 148.711C76.5918 147.85 75.9193 147.178 75.0582 146.984L67.7121 145.329C65.3342 144.793 65.3342 141.405 67.7121 140.869L75.0582 139.215C75.9193 139.021 76.5918 138.348 76.7858 137.487L78.4405 130.141Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_22254_1622",
    x: 7.93115,
    y: 28.9655,
    width: 184.138,
    height: 224.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 44.4444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.2222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0963041 0 0 0 0 0.0963041 0 0 0 0 0.0963041 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22254_1622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_22254_1622",
    x: 33.3333,
    y: 0.777794,
    width: 177.778,
    height: 211.111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.3333,
    result: "effect1_foregroundBlur_22254_1622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_22254_1622",
    x: 96.875,
    y: 102.641,
    width: 39.311,
    height: 39.3112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22254_1622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_22254_1622",
    x: 71.875,
    y: 90.9091,
    width: 19.6558,
    height: 19.6555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22254_1622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_22254_1622",
    x: 65.9287,
    y: 128.358,
    width: 29.4834,
    height: 29.4833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22254_1622"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlightBadge);
export default __webpack_public_path__ + "static/media/spotlight-badge.4723bd6b8801dab8ca79381841a5a4cd.svg";
export { ForwardRef as ReactComponent };